module.exports = __webpack_public_path__ + "media/svgs/text-request-portfolio-f5f4b20e370d0ff8ab5921cad6e9d1ae.svg";